import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-sidebar-menu-item',
    templateUrl: 'sidebar-menu-item.component.html',
    styleUrls: ['sidebar-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarMenuItemComponent implements OnInit {
    @Input()
    public link: any[];

    @Input()
    public params: { [k: string]: any };

    @Input()
    public disabled: boolean;

    @Input()
    public hasSubMenu: boolean;

    constructor() {}

    ngOnInit() {}
}
